import { render, staticRenderFns } from "./exhibition-photo.vue?vue&type=template&id=0a932be0&scoped=true&"
import script from "./exhibition-photo.vue?vue&type=script&lang=js&"
export * from "./exhibition-photo.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-photo.vue?vue&type=style&index=0&id=0a932be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a932be0",
  null
  
)

export default component.exports